import { createAsyncThunk } from '@reduxjs/toolkit';
import businessPipelinesService from 'services/businessPipelinesService';
import { RequestParams } from 'utils/mapParams';

export const getBusinessPipelinesList = createAsyncThunk(
  'businessPipelines/getBusinessPipelinesList',
  async (params: Partial<RequestParams>, thunkAPI) => {
    try {
      const res = await businessPipelinesService.getBusinessPipelinesList(params);
      return res;
    } catch (err: any) {
      if (!err.message) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.message.original);
    }
  }
);
